<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <div class="logo">
          <img src="/logo.png" alt="Logo" />
        </div>
        <h1>OKAKA</h1>
        <p>请选择您的身份登录</p>
      </div>

      <div class="role-selection">
        <div
          class="role-card"
          :class="{ active: selectedRole === 'student' }"
          @click="selectRole('student')"
        >
          <div class="role-icon student-icon">
            <i class="fa fa-graduation-cap"></i>
          </div>
          <div class="role-title">学生</div>
          <div class="role-desc">查看错题、学习分析、专项练习</div>
        </div>

<!--        <div-->
<!--          class="role-card"-->
<!--          :class="{ active: selectedRole === 'teacher' }"-->
<!--          @click="selectRole('teacher')"-->
<!--        >-->
<!--          <div class="role-icon teacher-icon">-->
<!--            <i class="fa fa-chalkboard-teacher"></i>-->
<!--          </div>-->
<!--          <div class="role-title">教师</div>-->
<!--          <div class="role-desc">管理班级、查看学生进度、布置作业</div>-->
<!--        </div>-->

        <div
          class="role-card"
          :class="{ active: selectedRole === 'parent' }"
          @click="selectRole('parent')"
        >
          <div class="role-icon parent-icon">
            <i class="fa fa-users"></i>
          </div>
          <div class="role-title">家长</div>
          <div class="role-desc">关注孩子学习、查看学习报告</div>
        </div>
      </div>

      <div class="login-form" v-if="selectedRole">
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
              size="large"
            ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              size="large"
              show-password
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              size="large"
              :loading="loading"
              @click="handleLogin"
              class="login-btn"
            >
              {{ loading ? '登录中...' : '登录' }}
            </el-button>
          </el-form-item>
        </el-form>

        <div class="demo-accounts">
          <p>演示账号：</p>
          <div class="demo-buttons">
            <el-button size="mini" @click="useDemoAccount('student')">学生账号</el-button>
<!--            <el-button size="mini" @click="useDemoAccount('teacher')">教师账号</el-button>-->
            <el-button size="mini" @click="useDemoAccount('parent')">家长账号</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axios } from "../config/axios";

export default {
  name: 'Login',
  data() {
    return {
      selectedRole: '',
      loading: false,
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    selectRole(role) {
      this.selectedRole = role;
      this.loginForm = {
        username: '',
        password: ''
      };
    },

    useDemoAccount(role) {
      this.selectedRole = role;
      const demoAccounts = {
        student: { username: 'student001', password: '123456' },
        teacher: { username: 'teacher001', password: '123456' },
        parent: { username: 'parent001', password: '123456' }
      };

      this.loginForm = demoAccounts[role];
    },

    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.login();
        }
      });
    },

    async login() {
      this.loading = true;

      try {
        // 模拟登录请求
        const response = await axios.post('/user/login', {
          account: this.loginForm.username,
          password: this.loginForm.password,
          role: this.selectedRole
        });

        if (response.data.code === 200) {
          // 保存用户信息到本地存储
          const userInfo = {
            username: this.loginForm.username,
            role: this.selectedRole,
            token: response.data.data.token || 'demo-token'
          };

          localStorage.setItem('userInfo', JSON.stringify(userInfo));

          // 根据角色跳转到对应页面
          this.redirectToRolePage();

          this.$message.success('登录成功！');
        } else {
          this.$message.error(response.data.message || '登录失败');
        }
      } catch (error) {
        console.error('登录错误:', error);

        // 演示模式：直接允许登录
        if (this.isDemoAccount()) {
          const userInfo = {
            username: this.loginForm.username,
            role: this.selectedRole,
            token: 'demo-token'
          };

          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.redirectToRolePage();
          this.$message.success('登录成功！（演示模式）');
        } else {
          this.$message.error('登录失败，请检查网络连接');
        }
      } finally {
        this.loading = false;
      }
    },

    isDemoAccount() {
      const demoAccounts = {
        student: { username: 'student001', password: '123456' },
        teacher: { username: 'teacher001', password: '123456' },
        parent: { username: 'parent001', password: '123456' }
      };

      const demo = demoAccounts[this.selectedRole];
      return demo && demo.username === this.loginForm.username && demo.password === this.loginForm.password;
    },

    redirectToRolePage() {
      const routes = {
        student: '/student/dashboard',
        teacher: '/teacher/dashboard',
        parent: '/parent/dashboard'
      };

      this.$router.push(routes[this.selectedRole]);
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 800px;
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 40px;

  .logo {
    margin-bottom: 20px;

    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  h1 {
    margin: 0 0 12px 0;
    font-size: 32px;
    font-weight: 700;
    color: #2c3e50;
    background: linear-gradient(135deg, #667eea, #764ba2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  p {
    margin: 0;
    color: #7f8c8d;
    font-size: 16px;
  }
}

.role-selection {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.role-card {
  background: #f8f9fa;
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  &:hover {
    background: #e9ecef;
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }

  &.active {
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: white;
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);

    .role-icon {
      background: rgba(255, 255, 255, 0.2);

      i {
        color: white;
      }
    }

    .role-title {
      color: white;
    }

    .role-desc {
      color: rgba(255, 255, 255, 0.9);
    }
  }
}

.role-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  transition: all 0.3s ease;

  i {
    font-size: 24px;
    transition: color 0.3s ease;
  }

  &.student-icon {
    background: linear-gradient(135deg, #4facfe, #00f2fe);

    i {
      color: white;
    }
  }

  &.teacher-icon {
    background: linear-gradient(135deg, #43e97b, #38f9d7);

    i {
      color: white;
    }
  }

  &.parent-icon {
    background: linear-gradient(135deg, #fa709a, #fee140);

    i {
      color: white;
    }
  }
}

.role-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  transition: color 0.3s ease;
}

.role-desc {
  font-size: 14px;
  color: #7f8c8d;
  line-height: 1.4;
  transition: color 0.3s ease;
}

.login-form {
  animation: fadeIn 0.4s ease-out;

  .el-form-item {
    margin-bottom: 24px;
  }

  .el-input {
    border-radius: 12px;

    /deep/ .el-input__inner {
      border-radius: 12px;
      border: 2px solid #e9ecef;
      padding: 12px 16px 12px 50px; // 增加左内边距为前缀图标留出空间
      height: 48px;
      font-size: 16px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
      }
    }

    /deep/ .el-input__prefix {
      left: 16px;
      top: 50%;
      transform: translateY(-50%); // 垂直居中对齐
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-input__icon {
        color: #7f8c8d;
        font-size: 16px;
        line-height: 1;
        transition: color 0.3s ease;
      }
    }

    // 当输入框获得焦点时，图标颜色也会改变
    /deep/ .el-input.is-focus .el-input__prefix .el-input__icon {
      color: #667eea;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-btn {
  width: 100%;
  height: 48px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
}

.demo-accounts {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e9ecef;
  text-align: center;

  p {
    margin: 0 0 12px 0;
    color: #7f8c8d;
    font-size: 14px;
  }
}

.demo-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;

  .el-button {
    border-radius: 20px;
    font-size: 12px;
    padding: 6px 16px;

    &:hover {
      transform: translateY(-1px);
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .login-container {
    padding: 15px;
  }

  .login-card {
    padding: 30px 20px;
  }

  .login-header {
    margin-bottom: 30px;

    h1 {
      font-size: 28px;
    }

    .logo img {
      width: 60px;
      height: 60px;
    }
  }

  .role-selection {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .role-card {
    padding: 20px;
  }

  .role-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 12px;

    i {
      font-size: 20px;
    }
  }

  .role-title {
    font-size: 16px;
  }

  .role-desc {
    font-size: 13px;
  }

  // 移动端输入框优化
  .login-form {
    .el-input {
      /deep/ .el-input__inner {
        padding: 10px 12px 10px 45px; // 减少移动端的内边距
        height: 44px; // 稍微减少高度
        font-size: 15px;
      }

      /deep/ .el-input__prefix {
        left: 14px;

        .el-input__icon {
          font-size: 15px;
        }
      }
    }

    .login-btn {
      height: 44px;
      font-size: 15px;
    }
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 25px 15px;
  }

  .login-header h1 {
    font-size: 24px;
  }

  .demo-buttons {
    flex-direction: column;
    align-items: center;

    .el-button {
      width: 120px;
    }
  }

  // 超小屏幕输入框进一步优化
  .login-form {
    .el-input {
      /deep/ .el-input__inner {
        padding: 8px 10px 8px 40px; // 进一步减少内边距
        height: 40px;
        font-size: 14px;
      }

      /deep/ .el-input__prefix {
        left: 12px;
        width: 16px;
        height: 16px;

        .el-input__icon {
          font-size: 14px;
        }
      }
    }

    .login-btn {
      height: 40px;
      font-size: 14px;
    }
  }
}
</style>
